import React from 'react';

/**
 * Get initials from name (first letter of first word + first letter of last word)
 */
const getInitials = (name) => {
  if (!name) return '?';
  const words = name.trim().split(/\s+/);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};

/**
 * Get Firebase URL for a user
 */
const getFirebaseUrl = (uid) => {
  return `https://console.firebase.google.com/u/1/project/projectblanche/firestore/databases/-default-/data/~2Fskiers~2F${uid}`;
};

/**
 * Reusable agent card component for virtual and live agents
 */
const AgentCard = ({
  agent,
  user,
  profilePictureUrl,
  showProfilePicture,
  isMenuOpen,
  onMenuToggle,
  onSwap,
  onRemove,
  onProfilePictureError,
  onUserClick,
  onNameClick,
  disabled = false,
  // Virtual-specific props
  stats = null,
  onAddBehavior = null,
  // Type indicator (reserved for future use)
  _isLive = false
}) => {
  return (
    <li className="name-item">
      <div className="agent-info">
        <div className="agent-header">
          {showProfilePicture ? (
            <img
              src={profilePictureUrl}
              alt={user?.name || 'Agent'}
              className="agent-card-profile-picture clickable"
              onClick={onUserClick}
              onError={onProfilePictureError}
            />
          ) : (
            <div 
              className="agent-card-initials clickable"
              onClick={onUserClick}
            >
              {user ? getInitials(user.name) : '?'}
            </div>
          )}
          <div className="agent-name-email">
            <span
              className={onNameClick ? "agent-name-clickable" : ""}
              onClick={onNameClick}
            >
              {user ? user.name : agent.uid}
            </span>
            {user?.email && (
              <span className="agent-email">{user.email}</span>
            )}
          </div>
        </div>
        {/* Stats section - only for virtual agents */}
        {stats && (
          <div className="agent-stats">
            <span className="stat-item">{stats.behaviorCount} behaviors</span>
            <span className="stat-item">{stats.totalMinutes} minutes</span>
          </div>
        )}
        {/* Add behavior button - only for virtual agents */}
        {onAddBehavior && (
          <button
            className="add-behavior-button"
            onClick={onAddBehavior}
            disabled={disabled}
          >
            + Add Behavior
          </button>
        )}
      </div>
      <div className="agent-menu-container">
        <button
          className="agent-menu-button"
          onClick={(e) => {
            e.stopPropagation();
            onMenuToggle();
          }}
          disabled={disabled}
        >
          ⋯
        </button>
        {isMenuOpen && (
          <div className="agent-menu-dropdown">
            <button
              className="agent-menu-item"
              onClick={(e) => {
                e.stopPropagation();
                onSwap();
              }}
            >
              <span className="menu-icon">⇄</span>
              Swap User
            </button>
            {agent.uid && (
              <a
                href={getFirebaseUrl(agent.uid)}
                target="_blank"
                rel="noopener noreferrer"
                className="agent-menu-item"
                onClick={(e) => {
                  e.stopPropagation();
                  onMenuToggle();
                }}
              >
                <span className="menu-icon">🔗</span>
                Jump to Firebase
              </a>
            )}
            <button
              className="agent-menu-item danger"
              onClick={(e) => {
                e.stopPropagation();
                onRemove();
              }}
            >
              <span className="menu-icon">✕</span>
              Remove
            </button>
          </div>
        )}
      </div>
    </li>
  );
};

export default AgentCard;
